export default {
  decks: [],
  loading: false
}
